module.exports = __webpack_public_path__ + "img/f1.b9ad6051.png";